var React = require('react');

function Checkmark (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M11.367 0l-6.48 6.48L2.081 3.67 0 5.753l4.887 4.89 8.561-8.563L11.367 0","fillRule":"evenodd"}));
}

Checkmark.displayName = "Checkmark";

Checkmark.defaultProps = {"viewBox":"0 0 14 11"};

module.exports = Checkmark;

Checkmark.default = Checkmark;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/checkmark.svg
// module id = 1263
// module chunks = 0